import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

const getServicePayments = (state: RootState) => {
	return state.servicePayments.servicePayments?.data;
};

export const getServicePaymentsSelector = createSelector(getServicePayments, (data) => data);

export const getServicePaymentsLoadingSelector = (state: RootState) => {
	return state.servicePayments.isLoading;
};

export const getServicePaymentsTotalSelector = (state: RootState) => {
	return state.servicePayments.servicePayments?.recordsTotal ?? 0;
};
